import styled from "styled-components";
import { TakerDataContainer } from "../../health/health-taker/taker-data-style";

export const HealthForeignersTakerContainer = styled(TakerDataContainer)``;
